import { useDispatch } from 'react-redux';
import { Grid, Button, Dialog, Box, Typography } from '@mui/material';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';

import {
  useGetAuthenticationQuery,
  useDeleteDomainControllerMutation,
} from '../../services/ADapi';

import { notificationSuccess } from '../../store/notificationReducer';

const DeleteDomainController = ({ domainControllerId, onClose }) => {
  const dispatch = useDispatch();
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const [deleteDomainController] = useDeleteDomainControllerMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: 'Domain controller deleted',
  };

  const deleteCollectionHandler = async () => {
    try {
      await deleteDomainController({
        user_id,
        domainControllerId,
      }).unwrap();
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      dispatch(
        notificationSuccess({
          ...notificationData,
          type: 'error',
          message: "Domain controller wasn't deleted",
        })
      );
    }
  };

  return (
    <Dialog open={true}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          height: '48px',
          margin: 'auto',
          borderRadius: '50%',
          backgroundColor: 'warning.light',
        }}
      >
        <GppBadOutlinedIcon
          fontSize="medium"
          sx={{ color: 'primary.contrastText' }}
        />
      </Box>
      <Typography variant="h2" sx={{ pt: 3, pb: 3, color: 'text' }}>
        Are you sure you want to delete this Domain Controller?
      </Typography>
      <Typography variant="body1" component="p" sx={{ pb: 3, color: 'text' }}>
        Deleting this controller will reassign all local domains linked to it to
        the primary controller
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Button
            variant="error"
            onClick={deleteCollectionHandler}
            size="small"
            sx={{
              width: '100%',
              backgroundColor: 'error.main',
              color: '#fff',
              '&:hover': {
                backgroundColor: 'error.main',
              },
            }}
          >
            Delete
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Button
            variant="outlined"
            onClick={onClose}
            size="small"
            sx={{
              width: '100%',
            }}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default DeleteDomainController;
